import mitt from "mitt";
import type { Smoke } from "../API";

type Events = {
  smoke: Smoke;
};

export const emitter = mitt<Events>();
